import { styled } from "@mui/system";

export const ContentContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: `0 ${theme.spacing(7)}`,
}));
